<template>
	<div class="bg-white border-y-3 border-gray-200">
		<div>
			<div class="flex items-stretch justify-between border-b border-gray-200">
				<span class="flex items-stretch text-sm text-gray-800 font-semibold uppercase p-3">
					<icon name="ri-map-pin-line" class="text-gray-400 mr-1" />
					<div>Ubicación</div>
				</span>
				<div v-if="props.lead.loc && props.lead.loc.coordinates[1] && props.lead.loc.coordinates[0]" class="px-3 py-1 flex flex-wrap justify-end gap-2">
					<Button
						v-if="user.permissions?.includes('lead.update.loc')"
						@click="
							router.push({
								name: 'go.leadLocation',
								query: {
									_id: props.lead._id,
									project: props.project
								}
							})
						"
						class="mr-1"
					>
						<icon name="ri-map-pin-line" class="mr-1" />
						Editar coordenadas
					</Button>
					<a :href="`https://www.google.com/maps/place/${props.lead.loc.coordinates[1]},${props.lead.loc.coordinates[0]}`" target="_blank" rel="noopener noreferrer" class="text-light-blue-500 underline">
						<button class="btn bg-green-600 hover:bg-green-500 text-white">
							<icon name="ri-road-map-line" class="opacity-70 w-5 h-5 mr-1" />
							Google Maps
						</button>
					</a>
				</div>
			</div>
			<div class="text-sm text-gray-800 p-3 flex flex-wrap gap-2 w-full">
				<div v-if="props.lead.contract.address.full" class="w-full flex items-center justify-between md:justify-start gap-4">
					<span>DIRECCIÓN:</span>
					<span :class="props.hideInfo ? 'blur-sm' : ''">{{ props.lead.contract.address.full }}</span></div>
				<div v-if="props.lead.contract.address.state" class="w-full flex items-center justify-between md:justify-start gap-4">
					<span>PROVINCIA:</span>
					<span :class="props.hideInfo ? 'blur-sm' : ''">{{ props.lead.contract.address.state }}</span></div>
				<div v-if="props.lead.contract.address.city" class="w-full flex items-center justify-between md:justify-start gap-4">
					<span>MUNICIPIO:</span>
					<span :class="props.hideInfo ? 'blur-sm' : ''">{{ props.lead.contract.address.city }}</span></div>
				<div v-if="props.lead.contract.address.zipcode" class="w-full flex items-center justify-between md:justify-start gap-4">
					<span>CÓDIGO POSTAL:</span>
					<span>{{ props.lead.contract.address.zipcode }}</span></div>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
import Button from '../../components/Button.vue'
import router from '@/router/router'
import { user } from '@/user'
import { Lead } from '../../interfaces/Lead'
const props = defineProps<{ project: string; lead: Lead, hideInfo?: boolean }>()
</script>
